import { motion } from 'framer-motion';
import { Outlet, useParams } from 'react-router-dom';

import { AppSidebar } from '../components/app-sidebar';
import { InconsistencyDrawer } from '../components/drawers/inconsistency-drawer';
import { ReferenceDrawer } from '../components/drawers/reference-drawer';
import { ErrorBoundary } from '../components/error-boundary';
import { FactPopup } from '../components/fact/fact-popup';
import { SidebarInset, SidebarProvider } from '../components/shadcn/sidebar';
import { cn } from '../lib/utils';
import { useGetMatterV2 } from '@/api/queries/useGetMatterV2';
import { useUserContext } from '@/Contexts/User';
import { DocViewerFullFact } from '@/new/components/doc-viewer/doc-viewer-full-fact';
import { useStore } from '@/store';

export function Layout() {
  const { subsetId, matterId } = useParams();

  const { user } = useUserContext();

  const popupFact = useStore((state) => state.popupFact);
  const setPopupFact = useStore((state) => state.setPopupFact);

  const { data: matter } = useGetMatterV2(matterId);

  const allDocumentsSubsetId = matter?.allDocumentsCaseId ?? null;
  const isInSubsetContext = subsetId !== undefined && allDocumentsSubsetId !== subsetId;

  if (!user) {
    return null;
  }

  return (
    <SidebarProvider>
      <div
        className={cn(
          isInSubsetContext ? 'via-cyan-200 to-cyan-400' : 'via-teal-100 to-teal-200',
          'font-inter flex h-screen w-full bg-gradient-to-b from-neutral-50 from-65% via-85% text-sm transition-colors duration-400',
        )}
      >
        <AppSidebar />
        <ReferenceDrawer />
        <FactPopup
          isOpen={popupFact !== null}
          toggleDrawer={() => setPopupFact(null)}
          position="left"
          width="725px"
          obscureBackground
        >
          {popupFact && (
            <motion.div key={popupFact.id}>
              <DocViewerFullFact subsetId={subsetId} factId={popupFact.id} showDocumentDetails={true} showComments />
            </motion.div>
          )}
        </FactPopup>
        <InconsistencyDrawer />

        <SidebarInset className="overflow-y-auto rounded-lg border border-black/10 bg-white">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
